/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GamePromotionalMessageCreateRequest
 */
export interface GamePromotionalMessageCreateRequest {
    /**
     * 
     * @type {Date}
     * @memberof GamePromotionalMessageCreateRequest
     */
    activeTo?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GamePromotionalMessageCreateRequest
     */
    activeFrom?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GamePromotionalMessageCreateRequest
     */
    message: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof GamePromotionalMessageCreateRequest
     */
    id?: string;
}

/**
 * Check if a given object implements the GamePromotionalMessageCreateRequest interface.
 */
export function instanceOfGamePromotionalMessageCreateRequest(value: object): value is GamePromotionalMessageCreateRequest {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function GamePromotionalMessageCreateRequestFromJSON(json: any): GamePromotionalMessageCreateRequest {
    return GamePromotionalMessageCreateRequestFromJSONTyped(json, false);
}

export function GamePromotionalMessageCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamePromotionalMessageCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'activeFrom': json['activeFrom'] == null ? undefined : (new Date(json['activeFrom'])),
        'message': json['message'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function GamePromotionalMessageCreateRequestToJSON(value?: GamePromotionalMessageCreateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'activeTo': value['activeTo'] == null ? undefined : ((value['activeTo'] as any).toISOString()),
        'activeFrom': value['activeFrom'] == null ? undefined : ((value['activeFrom'] as any).toISOString()),
        'message': value['message'],
        'id': value['id'],
    };
}

